// export const languageItem = (item, local) => {
//   let obj = {
//     key: item.key,
//     resource_id: item.resource_id,
//     coverImg: item.coverImg,
//     title: item.title[local],
//     type: item.report_type[local],
//     report_lang: item.report_lang[local],
//     summary: item.summary[local],
//     labelList: item.tag[local],
//     time: item.time,
//     source: item.source
//   }

//   return obj
// }

export const languageItem = (item: Record<string, any>, local: number) => {
  return {
    ...item,
    title: item.title?.[local],
    originTitle: item.originTitle?.[local],
    type: item.report_type?.[local],
    report_lang: item.report_lang?.[local],
    summary: item.summary?.[local],
    labelList: item.tag?.[local],
  };
};
